import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { IBrandingActions, II18nMessages } from '../../services/branding/models';
import { Redirect, Route, Switch, withRouter } from 'react-router';
import Login from './scenes/Login';
import { withJob } from 'react-jobs';
import AccountSummary from './scenes/AccountSummary';
import CustomerClaims from './scenes/CustomerClaims';
import PolicyDetail from './scenes/PolicyDetail';
import ForgottenPassword from './scenes/ForgottenPassword';
import ResetPassword from './scenes/ResetPassword';
import CreateAnAccount from './scenes/CreateAnAccount';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, get } from 'lodash';
import { actions as authActions, IAuthActions } from '../../services/auth/reducer';
import { IAuthState } from '../../services/auth/models';
import SetPassword from './scenes/SetPassword';
import DocumentsArea from './scenes/PolicyDetail/components/DocumentsArea';
import { IStore } from '../../redux/IStore';
import FAQ from './scenes/FAQ';
import ManageAccount from './scenes/ManageAccount';
import MakeAChange from './scenes/MakeAChange';
import MakeAChangeSelection from './scenes/MakeAChange/components/MakeAChangeSelection';
import CoverDetails from './scenes/MakeAChange/components/CoverDetails';
import PersonalDetails from './scenes/MakeAChange/components/PersonalDetails';
import MakeAChangeComplete from './scenes/MakeAChange/components/Complete';
import MtaSelect from './scenes/MakeAChange/components/CoverDetails/scenes/MTASelect';
import MTAAdditionalCoverForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAAdditionalCoverForm';
import MTASummaryForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTASummaryForm';
import MTAAdditionalTravellersForm
  from './scenes/MakeAChange/components/CoverDetails/scenes/MTAAdditionalTravellersForm';
import MTAMedicalDeclarationForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAMedicalDeclarationForm';
import ErrorBoundary from '../../components/ErrorBoundary';
import MTAChangeRegionForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAChangeRegionForm';
import MTAChangeDestinationForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAChangeDestinationForm';
import MTAChangeTripDateForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAChangeTripDateForm';
import SingleTripCancelReason from './scenes/MakeAChange/components/CancelPolicy/SingleTripCancelReason';
import CancelPolicyComplete from './scenes/MakeAChange/components/CancelPolicy/CancelPolicyComplete';
import MTARemoveTravellerForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTARemoveTravellerForm';
import MTAChangeTierForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAChangeTierForm';
import MTAChangeTripTypeForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAChangeTripType';
import AMTUpsell from './scenes/MakeAChange/components/AMTUpsell';
import RenewalEdit from './scenes/RenewalEdit';
import RedirectHelper from './scenes/RedirectHelper';
import RenewalMedicalDecline from './scenes/RenewalEdit/components/RenewalMedicalDecline';
import RenewalCallCentre from './scenes/RenewalEdit/components/RenewalCallCentre';
import RedirectToMtaUpsell from './scenes/MakeAChange/components/RedirectToMtaUpsell';
import CancelPolicy from './scenes/MakeAChange/components/CancelPolicy';
import CancelConfirm from './scenes/MakeAChange/components/CancelPolicy/CancelConfirm';
import AMTCancelReason from './scenes/MakeAChange/components/CancelPolicy/AMTCancelReason';
import DiscountAppliedComplete from './scenes/MakeAChange/components/CancelPolicy/DiscountAppliedComplete';
import RedirectToMtaRegion from './scenes/MakeAChange/components/RedirectToMtaRegion';
import RedirectToMtaUpgradeTier from './scenes/MakeAChange/components/RedirectToMtaUpgradeTier/index';
import CancelRenewal from './scenes/MakeAChange/components/CancelRenewal';
import RenewalCancelReason from './scenes/MakeAChange/components/CancelRenewal/RenewalCancelReason';
import RenewalDiscountAppliedComplete
  from './scenes/MakeAChange/components/CancelPolicy/RenewalDiscountAppliedComplete';
import MTAChangeTripDurationForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTAChangeTripDurationForm';
import MTARemoveOptionForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTARemoveOptionForm';
import { Promise } from 'es6-promise';
import Loading from '../../components/Loading';
import { actions as brandingActions } from '../../services/branding/reducer';
import CustomerOffers from './scenes/CustomerOffers';
import QuotesSummary from './scenes/QuotesSummary';
import QuoteDetail from './scenes/QuoteDetail';
import LogoutListener from '../../components/LogoutListener';
import { mtaActions } from '../../services/mta/actions';
import { IMtaActions } from '../../services/mta/models';
import { ChatWidget } from '../../helpers/ChatWidget';
import AMTUpsellLanding from './scenes/MakeAChange/components/RedirectToAMTUpsellLanding';
import MTACustomerUpsellForm from './scenes/MakeAChange/components/CoverDetails/scenes/MTACustomerUpsellForm';
import RedirectToMtaAdditional from './scenes/MakeAChange/components/RedirectToMtaAdditional';
import NotAllowed from './scenes/MakeAChange/components/NotAllowed';
import HolidayChecklist from './scenes/HolidayChecklist';

interface ICustomerAreaProps {
  i18n: II18nMessages;
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push(route: string);
    branding: IBrandingActions,
    mta: IMtaActions,
  };
  location: Location;
}

class CustomerAreaNew extends React.Component<ICustomerAreaProps> {
  public componentDidMount() {
    ChatWidget();
    if (process.env.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  public componentDidUpdate(prevProps: Readonly<ICustomerAreaProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      ChatWidget();
    }
  }

  private renderAuthenticatedRoutes = () => {
    const hideFAQ = false;

    return (
      <Switch>
        <Redirect from="/auth" to="/account/summary"/>
        <Route exact={true} path="/account/logout" component={LogoutListener}/>
        <Route exact={true} path="/account/summary" component={AccountSummary}/>
        <Route exact={true} path="/account/policies/:id" component={PolicyDetail}/>
        <Route exact={true} path="/account/quotes/:id" component={QuoteDetail}/>
        <Route exact={true} path="/account/amt-upsell" component={AMTUpsellLanding}/>
        <Route exact={true} path="/account/renewals/medical-decline" component={RenewalMedicalDecline}/>
        <Route exact={true} path="/account/renewals/call-centre" component={RenewalCallCentre}/>
        <Route exact={true} path="/account/renewals/:id/documents" component={DocumentsArea}/>
        <Route exact={true} path="/account/renewals/:id/:params?" component={RenewalEdit}/>
        <Route exact={true} path="/account/quotes/:id/documents" component={DocumentsArea}/>
        <Route exact={true} path="/account/policies/:id/documents" component={DocumentsArea}/>
        <Route exact={true} path="/account/policies/:id/checklist" component={HolidayChecklist}/>
        <Route exact={true} path="/account/quotes/" component={QuotesSummary}/>
        <Route exact={true} path="/account/make-a-change/" component={MakeAChange}/>
        <Route exact={true} path="/account/make-a-change/contact" component={NotAllowed}/>
        <Route exact={true} path="/account/make-a-change/selection/:id" component={MakeAChangeSelection}/>
        <Route exact={true} path="/account/make-a-change/personal-details/:id" component={PersonalDetails}/>
        <Route exact={true} path="/account/make-a-change/cover-details/:id" component={CoverDetails}/>
        <Route exact={true} path="/account/make-a-change/cancel-policy" component={CancelPolicy}/>
        <Route exact={true} path="/account/make-a-change/cancel-renewal/:id?" component={CancelRenewal}/>
        <Route exact={true} path="/account/make-a-change/amt-upsell" component={AMTUpsell}/>
        <Route exact={true} path="/account/make-a-change/single-trip-cancel-reason/:id"
               component={SingleTripCancelReason}/>
        <Route exact={true} path="/account/make-a-change/amt-cancel-reason/:id" component={AMTCancelReason}/>
        <Route exact={true} path="/account/make-a-change/renewal-cancel-reason" component={RenewalCancelReason}/>
        <Route exact={true} path="/account/make-a-change/amt-cancel-reason/redirect-to-mta-region/:id"
               component={RedirectToMtaRegion}/>
        <Route exact={true} path="/account/make-a-change/amt-cancel-reason/redirect-to-mta-upgrade-tier/:id"
               component={RedirectToMtaUpgradeTier}/>
        <Route exact={true} path="/account/make-a-change/cancel-confirm" component={CancelConfirm}/>
        <Route exact={true} path="/account/make-a-change/mta/select" component={MtaSelect}/>
        <Route exact={true} path="/account/make-a-change/mta/additional-cover" component={MTAAdditionalCoverForm}/>
        <Route exact={true}
               path="/account/make-a-change/mta/additional-travellers"
               component={MTAAdditionalTravellersForm}/>
        <Route exact={true}
               path="/account/make-a-change/mta/medical-declaration"
               component={MTAMedicalDeclarationForm}/>
        <Route exact={true} path="/account/make-a-change/mta/change-region" component={MTAChangeRegionForm}/>
        <Route exact={true} path="/account/make-a-change/mta/change-destination" component={MTAChangeDestinationForm}/>
        <Route exact={true} path="/account/make-a-change/mta/change-trip-date" component={MTAChangeTripDateForm}/>
        <Route exact={true} path="/account/make-a-change/mta/remove-traveller" component={MTARemoveTravellerForm}/>
        <Route exact={true} path="/account/make-a-change/mta/change-tier" component={MTAChangeTierForm}/>
        <Route exact={true} path="/account/make-a-change/mta/change-trip-duration"
               component={MTAChangeTripDurationForm}/>
        <Route exact={true} path="/account/make-a-change/mta/remove-option" component={MTARemoveOptionForm}/>
        <Route exact={true} path="/account/make-a-change/mta/change-trip-type" component={MTAChangeTripTypeForm}/>
        <Route exact={true} path="/account/make-a-change/mta/customer-upsell" component={MTACustomerUpsellForm}/>
        <Route exact={true} path="/account/make-a-change/mta/summary" component={MTASummaryForm}/>
        <Route exact={true} path="/account/make-a-change/complete" component={MakeAChangeComplete}/>
        <Route exact={true} path="/account/make-a-change/cancellation-complete" component={CancelPolicyComplete}/>
        <Route exact={true} path="/account/make-a-change/discount-applied-complete"
               component={DiscountAppliedComplete}/>
        <Route exact={true} path="/account/make-a-change/renewal-discount-applied-complete"
               component={RenewalDiscountAppliedComplete}/>
        <Route exact={true} path="/account/claims" component={CustomerClaims}/>
        <Route exact={true} path="/account/offers" component={CustomerOffers}/>
        <Route exact={true} path="/account/redirect-to-mta-upsell/:id" component={RedirectToMtaUpsell}/>
        <Route exact={true} path="/account/redirect-to-mta-additional/:id" component={RedirectToMtaAdditional}/>
        <Redirect from="/account/make-a-change/redirect-to-renewals/:id/:params?" to={{
          pathname: '/account/renewals/:id/:params?',
          state: { from: this.props.location }
        }}/>
        {!hideFAQ && (
          <Route exact={true} path="/account/faqs" component={FAQ}/>
        )}
        <Route exact={true} path="/account/manage" component={ManageAccount}/>
        <Route exact={true} path="/account/redirect" component={RedirectHelper}/>
      </Switch>
    );
  }

  private renderUnauthenticatedRoutes = () => {
    return (
      <Switch>
        <Redirect from="/account/logout" to={{ pathname: '/auth/login' }}/>
        <Redirect from="/account" to={{
          pathname: '/auth/login',
          search: 'returnTo=' + this.props.location.pathname,
          state: { from: this.props.location },
        }}/>
        <Route exact={true} path="/auth/login" component={Login}/>
        <Route exact={true} path="/auth/remind" component={ForgottenPassword}/>
        <Route exact={true} path="/auth/create-an-account" component={CreateAnAccount}/>
        <Route exact={true} path="/password/reset/:token/:email" component={ResetPassword}/>
        <Route exact={true} path="/password/set/:token/:email" component={SetPassword}/>
        <Route exact={true} path="/password/set/:token" component={SetPassword}/>
      </Switch>
    );
  }

  public render() {
    const { auth } = this.props;

    return (
      <ErrorBoundary {...this.props}>
        <div className="internal-page">
          <div className="container">
            <Row>
              <Col md={12}>
                <div className="customer-area-container">
                  {auth.isAuthenticated && (
                    <>
                      {this.renderAuthenticatedRoutes()}
                    </>
                  )}
                  {!auth.isAuthenticated && (
                    this.renderUnauthenticatedRoutes()
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default flow([
  withJob({
    work: (props: ICustomerAreaProps) => {
      const promises = [];
      const isLoggedIn = window.sessionStorage.getItem('authenticated') === 'true'
      if (!props.auth.isAuthenticated && isLoggedIn) {
        const route = get(props, 'location.pathname')
        let redirect = null;
        if (route.includes('/account/make-a-change/mta/')) {
          redirect = '/account/summary/';
        }
        promises.push(props.actions.auth.reAuthenticateCustomer(redirect));

        return Promise.all(promises);
      }
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(CustomerAreaNew);
